import React, { useRef } from 'react'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { supabase } from '../App'
import { Links } from '../data/categories'
import { useOnClickOutside } from '../hooks/useOnClickOutside'
import { setModal } from '../redux/modals-reducer'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

const Burger = (props) => {
    const dispatch = useDispatch()

    const ref = useRef(null)
    useOnClickOutside(ref, () => props.set(false))

    let user = supabase.auth.user()

    if (props.show) {
        disableBodyScroll(document.body)
    } else {
        enableBodyScroll(document.body)
    }
    console.log(props.show)

    return (
        <>
            <StyledBurger show={props.show}>
                <div
                    className="burger_wrapper"
                    style={props.show ? { zIndex: '200', background: "rgba(140, 149, 165, 0.6)" } : null}
                >
                    <div className="content" ref={ref}>
                        <div className="head">
                            {user ? (
                                <Link to="/profile" className="row">
                                    <img
                                        className="logo"
                                        src="/images/primary/avatar.jpeg"
                                        alt="logo"
                                    />
                                    <p>
                                        {user.user_metadata.first_name}{' '}
                                        {user.user_metadata.second_name}
                                    </p>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            d="M9 19a1 1 0 01-.71-.29 1 1 0 010-1.42l5.3-5.29-5.3-5.29a1 1 0 011.42-1.42l6 6a1 1 0 010 1.42l-6 6A1 1 0 019 19z"
                                            fill="currentColor"
                                        ></path>
                                    </svg>
                                </Link>
                            ) : (
                                <>
                                    <p>Hi there!</p>
                                    <span>
                                        <h5
                                            onClick={(e) => {
                                                e.preventDefault()
                                                props.set(false)
                                                dispatch(setModal('AUTH'))
                                            }}
                                        >
                                            Log In
                                        </h5>{' '}
                                        or{' '}
                                        <h5
                                            onClick={(e) => {
                                                e.preventDefault()
                                                props.set(false)
                                                dispatch(setModal('REGISTER'))
                                            }}
                                        >
                                            Sign up
                                        </h5>
                                    </span>
                                </>
                            )}
                        </div>
                        <nav>
                            {Links.map((link) => (
                                <div className="link">
                                    <div className="image"></div>
                                    <Link to={`/catalog/${link.id}`}>
                                        {link.category}
                                    </Link>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            d="M9 19a1 1 0 01-.71-.29 1 1 0 010-1.42l5.3-5.29-5.3-5.29a1 1 0 011.42-1.42l6 6a1 1 0 010 1.42l-6 6A1 1 0 019 19z"
                                            fill="currentColor"
                                        ></path>
                                    </svg>
                                </div>
                            ))}
                        </nav>
                        <div className="footer">
                            <a href="/">Delivery</a>
                            <a href="/">Returns</a>
                            <a href="/">Help Center</a>
                            <a href="/">Sell Your Art</a>
                        </div>
                    </div>
                </div>
            </StyledBurger>
        </>
    )
}

export default Burger

const StyledBurger = styled.div`
    .burger_wrapper {
        position: fixed;
        z-index: -1;
        top: 0;
        left: 0;
        min-height: 100vh;
        height: 100%;
        transition: 0.5s all ease;
        width: 100vw;
    }
    .content {
        position: relative;
        z-index: 10000;
        height: 100%;
        width: 300px;
        background: #fff;
        overflow-y: scroll;
        transition: 0.5s all ease;
        transform: translateX(${(props) => (props.show ? '0' : '-300px')});
    }
    .logo {
        background: gray;
        border-radius: 50%;
        margin-right: 15px;
        width: 48px;
        height: 48px;
    }
    .row {
        display: flex;
        align-items: center;
        svg {
            margin-left: auto;
        }
    }
    .head {
        box-sizing: border-box;
        padding: 16px;
        background: rgba(233, 233, 240, 0.6);
        img {
            width: 48px;
            height: 48px;
        }
        p {
            height: 26px;
            font-size: 16px;
        }
        span {
            display: flex;
            font-size: 16px;
        }
        h5 {
            font-size: 16px;
            font-weight: 600;
        }
        h5:nth-child(1) {
            margin-right: 5px;
        }
        h5:nth-child(2) {
            margin-left: 5px;
        }
    }

    nav {
        display: flex;
        flex-direction: column;
        border-bottom: 1px solid gray;
    }
    svg {
        width: 24px;
        height: 24px;
        margin-left: auto;
    }
    .image {
        width: 48px;
        height: 48px;
        background: gray;
        border-radius: 5px;
        margin-right: 10px;
    }
    a {
        font-weight: 500;
    }
    .link {
        padding: 16px;
        display: flex;
        align-items: center;
        &:nth-child(n + 2) {
            border-top: 1px solid gray;
        }
    }

    .footer {
        padding: 16px 16px 48px;
        display: flex;
        flex-direction: column;
        a {
            font-weight: 400;
            font-size: 15px;
        }
        a:nth-child(n + 2) {
            margin-top: 10px;
        }
    }
`
